import React, { useState } from 'react';
import OTPInput from 'otp-input-react';
import { FaEnvelope } from 'react-icons/fa';
import { BiSolidPhone } from "react-icons/bi";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import http from "../services/http";
import { Modal, Button } from 'react-bootstrap';
import Logo from "../assets/images/logo.png";

const UserVerificationByEmailPhone = () => {
  const [emailOTP, setEmailOTP] = useState('');
  const [phoneOTP, setPhoneOTP] = useState('');
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const userDetails = localStorage.getItem('signupUserDetails');
  const { email, phone, id } = JSON.parse(userDetails);


  const navigate = useNavigate();

  // Handle resend click - Navigate to the resend screen
  const handleResendClick = () => {
    // navigate('/resend-otp');
    setIsDialogOpen(true);

  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!emailOTP || !phoneOTP) {
      toast.error("Both OTPs are required!");
      return;
    }

    try {
      http
        .post(`public/analyst/email-phone-verify`, {
          email_code: emailOTP,
          phone_code: phoneOTP,
        })
        .then((res) => {
          toast.success(res.data.message);
          setTimeout(() => {
            navigate('/');
          }, 3000)

        })
        .catch((error) => {

          if (error.response) {
            if (error.response.data.errors) {
              for (let key in error.response.data.errors) {
                toast.error(error.response.data.errors[key]);
              }
            } else if (error.response.data.message) {
              toast.error(error.response.data.message);
            }
          }
        });
    } catch (error) {
      toast.error("An error occurred during verification.");
    }
  };

  // Handle update user info
  const handleUpdateInfo = () => {
    // Navigate to a page where user can update their info
    navigate('/edit-info');
    setIsDialogOpen(false);
  };

  // Handle send OTP
  const handleSendOtp = async () => {
    try {
   
      http
        .post(`public/analyst/resend-otp/email-phone`, {
          analyst_id: id,
          email: email,
          phone: phone,
        })
        .then((res) => {
          toast.success("OTP code sent to your email and phone.");
        })
        .catch((error) => {

          if (error.response) {
            if (error.response.data.errors) {
              for (let key in error.response.data.errors) {
                toast.error(error.response.data.errors[key]);
              }
            } else if (error.response.data.message) {
              toast.error(error.response.data.message);
            }
          }
        });

      setIsDialogOpen(false);
    } catch (error) {
      toast.error("Failed to resend OTP.");
    }
  };

  return (
    <>
      <section className="otp_verification custom_hight mt-5">
        <div className="login_inner pt-0">
          <div className="login_logo mb_40">
            <img src={Logo} alt="" />
          </div>
          <h1 className="mb_30 main_title">Verify Your Email & Phone</h1>
          <p className="mb_40 them_para text-center mx-auto">
            We have sent a 6 digit OTP to your email and phone.
            <br />
            Please enter the OTPs to continue.
          </p>

          {/* Email OTP Row */}
          <div className="otp_row">
            <div className="otp_icon_input_wrap">
              <FaEnvelope className="otp_icon" size={30} />
              <OTPInput
                value={emailOTP}
                onChange={setEmailOTP}
                OTPLength={6}
                otpType="number"
                inputStyles={{ width: 60, height: 60 }}
                inputClassName="otp_input"
              />
            </div>
          </div>

          {/* Phone OTP Row */}
          <div className="otp_row">
            <div className="otp_icon_input_wrap">
              <BiSolidPhone className="otp_icon" size={30} />
              <OTPInput
                value={phoneOTP}
                onChange={setPhoneOTP}
                OTPLength={6}
                otpType="number"
                inputStyles={{ width: 60, height: 60 }}
                inputClassName="otp_input"
              />
            </div>
          </div>

          <div className="btn_wraper">
            <button
              type="submit"
              className="them_btn mt_40 mb_30"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>

          <div className="otp-resend">
            <p className="opt-receive-code">Didn't Receive Code?</p>
            <p className="otp-btn-link" onClick={handleResendClick}>
              Resend Code
            </p>
          </div>
        </div>
      </section>

      <Modal show={isDialogOpen} onHide={() => setIsDialogOpen(false)}>
        <Modal.Body>
          <div className="modal-content">
            <div className="modal-header pb-0">
              <p className="otp_dialog_main_title text-center">Your Current Details</p>
              <button
                onClick={() => setIsDialogOpen(false)}
                type="button"
                className="close"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p>Current Email: <strong>{email}</strong></p>
              <p>Current Phone: <strong>{phone}</strong></p>
              <p className='mt-5'>Do you want to update your email or phone information?<br /><br /> If you do, click on <strong>Update Information.</strong> <br /><br />Otherwise, click <strong>Get OTP</strong> to receive the OTP at your current contact details.</p>
              <div className="btn_wraper d-flex justify-content-end mt-5">
                <button
                  type="button"
                  className="them_btn"
                  style={{ marginRight: '10px' }}
                  onClick={handleUpdateInfo}
                >
                  Update Information
                </button>
                <button
                  type="button"
                  className="them_btn"
                  onClick={handleSendOtp}
                >
                  Get OTP
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>


      <ToastContainer />
    </>
  );
};

export default UserVerificationByEmailPhone;
